var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { $paymentMethods } from 'ziphy-web-shared/basic/entities/paymentMethods';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import Toolbar from '@nedoShared/features/layouts/toolbar/Toolbar';
import PaymentMethodsList from '@nedoShared/features/paymentMethods/paymentMethodsController/paymentMethodsList/PaymentMethodsList';
import { routeActions } from '@config/routeActions';
const PaymentMethodsPage = () => {
    const { t } = useTranslation();
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        yield $paymentMethods.list();
    }));
    return (_jsxs("div", Object.assign({ className: "content" }, { children: [_jsx(Toolbar, { goBackProps: { autoTarget: routeActions.HOME() } }), _jsxs("div", Object.assign({ className: "container" }, { children: [_jsx(Title, Object.assign({ size: 'h1' }, { children: t('label.payment_methods') })), _jsx(WithLoaderWrapper, Object.assign({ isLoading: isLoading, className: "mt-30 max_width--lg" }, { children: _jsx(PaymentMethodsList, {}) }))] }))] })));
};
export default observer(PaymentMethodsPage);
